import { render, staticRenderFns } from "./ReceiptInfo.vue?vue&type=template&id=7361a69c&scoped=true&"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js&"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInfo.vue?vue&type=style&index=0&id=7361a69c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7361a69c",
  null
  
)

export default component.exports